import { Result, Descriptions } from 'antd';

export default function StepGenerateNewStatement({
  patchStatus,
  reportingCycles
}) {
  return <>
    <Result
      status="success"
      title="Successfully Patched and Generated new Statements!"
      subTitle=""
      />
    <Descriptions layout="vertical" bordered column={4} size="small">
      <Descriptions.Item label="Statements Patched" span={2}>
        <Descriptions layout="horizontal" bordered column={2} size="small">
          <Descriptions.Item label="Total Statements" span={2}>{ Object.values(patchStatus).length }</Descriptions.Item>
          <Descriptions.Item label="Patched Statements" span={2}>{ Object.values(patchStatus).filter((status) => status.status).length }</Descriptions.Item>
        </Descriptions>
      </Descriptions.Item>
      <Descriptions.Item label="New Statements Created" span={2}>
        <Descriptions layout="horizontal" bordered column={2} size="small">
          <Descriptions.Item label="Total Statements" span={2}>{ Object.values(reportingCycles).length }</Descriptions.Item>
          <Descriptions.Item label="Created Statements" span={2}>{ Object.values(reportingCycles).filter((status) => status.status && status.shouldPersist).length }</Descriptions.Item>
        </Descriptions>
      </Descriptions.Item>
    </Descriptions>
  </>
}